import { render, staticRenderFns } from "./EquipesMobiles.vue?vue&type=template&id=13c6803b&scoped=true"
import script from "./EquipesMobiles.vue?vue&type=script&lang=js"
export * from "./EquipesMobiles.vue?vue&type=script&lang=js"
import style0 from "./EquipesMobiles.vue?vue&type=style&index=0&id=13c6803b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6803b",
  null
  
)

export default component.exports